/*
  20 Oct 2026: searches that name a Penang-area town ("birthday flowers penang", "cake butterworth") only show
  products we can deliver there. Shopify search matches words loosely, so "birthday flowers penang" used to list
  Klang Valley bouquets first. Every Penang product carries the "penang" tag, and search accepts "tag:penang".
  - Search dropdown: the product list comes from a second request with the place words swapped for tag:penang;
    collection suggestions (e.g. Birthday Flowers Penang) still come from what the shopper typed.
  - Search page: the query is sent as "<words> tag:penang", and the box shows "<words> in Penang".
*/
(() => {
  if (window.ghRegionSearch) return;
  window.ghRegionSearch = true;

  const PLACES = [
    'pulau pinang', 'penang', 'george town', 'georgetown', 'butterworth', 'bukit mertajam', 'bayan lepas',
    'batu kawan', 'nibong tebal', 'seberang perai', 'sungai petani', 'kulim', 'gelugor', 'jelutong',
    'air itam', 'tanjung bungah', 'balik pulau', 'jawi',
  ];
  const placeRe = new RegExp(`\\b(${PLACES.map((p) => p.replace(/ /g, '\\s+')).join('|')})\\b`, 'gi');
  const TAG = 'tag:penang';

  const hasPlace = (q) => { placeRe.lastIndex = 0; return placeRe.test(q); };

  // "birthday flowers in penang" -> "birthday flowers tag:penang"; null when the query names no Penang place.
  const narrow = (q) => {
    if (!q || /\btag:/i.test(q) || !hasPlace(q)) return null;
    const words = q.replace(placeRe, ' ').replace(/\b(in|at|to|near)\b/gi, ' ').replace(/\s+/g, ' ').trim();
    return words ? `${words} ${TAG}` : TAG;
  };

  // Search dropdown.
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input && input.url;
    if (!url || !url.includes('section_id=predictive-search')) return nativeFetch(input, init);

    const original = new URL(url, window.location.origin);
    const narrowed = narrow(original.searchParams.get('q') || '');
    if (!narrowed) return nativeFetch(input, init);

    const penangUrl = new URL(original);
    penangUrl.searchParams.set('q', narrowed);
    const [base, penang] = await Promise.all([
      nativeFetch(original.toString(), init),
      nativeFetch(penangUrl.toString(), init).catch(() => null),
    ]);
    if (!base.ok || !penang || !penang.ok) return base;

    const [baseHtml, penangHtml] = await Promise.all([base.text(), penang.text()]);
    const parser = new DOMParser();
    const baseDoc = parser.parseFromString(baseHtml, 'text/html');
    const penangDoc = parser.parseFromString(penangHtml, 'text/html');
    const baseList = baseDoc.querySelector('#psearch-products .predictive-search__list');
    const penangList = penangDoc.querySelector('#psearch-products .predictive-search__list');
    if (baseList && penangList && penangList.querySelector('.predictive-search__item:not(.js-submit)')) {
      baseList.replaceWith(baseDoc.importNode(penangList, true));
    }
    return new Response(baseDoc.body.innerHTML, {
      status: base.status,
      headers: { 'Content-Type': 'text/html; charset=utf-8' },
    });
  };

  // Search form submits (header, search page, the dropdown's "view all" button).
  document.addEventListener('submit', (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement) || !/\/search\b/.test(form.getAttribute('action') || '')) return;
    const field = form.querySelector('input[name="q"]');
    if (!field) return;
    const narrowed = narrow(field.value);
    if (narrowed) field.value = narrowed;
  }, true);

  // Search results page: follow old links, and show the query the way the shopper would write it.
  const params = new URLSearchParams(window.location.search);
  if (window.location.pathname.replace(/\/$/, '').endsWith('/search') && params.has('q')) {
    const q = params.get('q');
    const narrowed = narrow(q);
    if (narrowed) {
      params.set('q', narrowed);
      window.location.replace(`${window.location.pathname}?${params}`);
      return;
    }
    if (q.toLowerCase().includes(TAG)) {
      const pretty = `${q.replace(/\s*tag:penang\s*/i, ' ').trim()} in Penang`.trim();
      const tidy = () => {
        document.querySelectorAll('input[name="q"]').forEach((el) => {
          if (el.value.toLowerCase().includes(TAG)) el.value = pretty;
        });
        const walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (node.nodeValue.toLowerCase().includes(TAG)) node.nodeValue = node.nodeValue.replace(q, pretty);
        }
        document.title = document.title.replace(q, pretty);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy);
      else tidy();
    }
  }
})();
